import { create } from 'zustand';

/** 满屏 section 定义 */
export interface FullPageSection {
  id: string;
  label: string;      // 右侧圆点 tooltip
  icon?: string;      // fa icon
}

/** 顺序即上下滚动顺序 */
export const FULLPAGE_SECTIONS: FullPageSection[] = [
  { id: 'hero',       label: '首页',       icon: 'fa-house' },
  { id: 'cases',      label: '项目案例',   icon: 'fa-briefcase' },
  { id: 'gtm',        label: '战役沉淀',   icon: 'fa-chess' },
  { id: 'tech',       label: '能力图谱',   icon: 'fa-sitemap' },
  { id: 'contact',    label: '认证与荣誉', icon: 'fa-envelope-open-text' },
];

interface FullPageState {
  index: number;
  isAnimating: boolean;
  setIndex: (i: number, source?: 'wheel' | 'dot' | 'key' | 'init') => void;
  next: () => void;
  prev: () => void;
  setAnimating: (b: boolean) => void;
}

export const useFullPageStore = create<FullPageState>((set, get) => ({
  index: 0,
  isAnimating: false,
  setIndex: (i, _source = 'init') => {
    const clamped = Math.max(0, Math.min(FULLPAGE_SECTIONS.length - 1, i));
    if (clamped === get().index) return;
    set({ index: clamped, isAnimating: true });
    // 动画结束后放开
    window.setTimeout(() => set({ isAnimating: false }), 800);
  },
  next: () => get().setIndex(get().index + 1),
  prev: () => get().setIndex(get().index - 1),
  setAnimating: (b) => set({ isAnimating: b }),
}));
